exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".body-table[data-v-5a10ef78]{height:calc(100% - 32px - 1.75rem - 30px)!important}.body-table .cln-libelle[data-v-5a10ef78]{-ms-flex-positive:1;flex-grow:1}.body-table .cln-action[data-v-5a10ef78]{width:15%}.body-table tbody .cln-libelle[data-v-5a10ef78]{-ms-flex-positive:1;flex-grow:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5a10ef78","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/listeFeatureFlag/listeFeatureFlag.scss
// module id = 2aja
// module chunks = 2